import fragmentCustomExtendedProductFields from '~/modules/GraphQL/customQueries/fragments/fragmentCustomExtendedProductFields';

export default `
  #graphql
  fragment ProductFields on ProductInterface {
    ...CustomExtendedProductFields
    __typename
    id
    uid
    sku
    stock_status
    name
    new_from_date
    new_to_date
    manufacturer
    bestseller
    recommended
    special_price
    special_to_date
    special_from_date
    main_category
    categories {
      id
      name
      level
      path
    }
    productAttachments {
      type
      file
      url
      title
    }
    short_description {
      html
      __typename
    }
    description {
      html
    }

    stock_item {
      qty_increments
      min_sale_qty
      max_sale_qty
    }
    thumbnail {
      url
      position
      disabled
      label
    }
  }
  ${fragmentCustomExtendedProductFields}
`;
